import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../../contexts/GlobalContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { keyUserId, keyAccessToken, userEmail } from "../../../../../assets/js/SessionStorageNames";
import axios from "axios";
import { Modal, Button, Form } from "react-bootstrap";
import FileSaver from 'file-saver';
import { getReport } from "../../../../../hooks/api/cashea";
import { getReportHomeCenter } from "../../../../../hooks/api/homeCenter";
import { apiRoutes } from "../../../../../config";
import { downloadReport } from "../../../../../hooks/api/reports";
import { getPricelists as getPricelistsFromAPI } from "../../../../../hooks/api/prices";
import { getReportVtex } from "../../../../../hooks/api/vtex";
import { getReportFalabella } from "../../../../../hooks/api/falabella";
import { getOdooProductsReport } from "../../../../../hooks/api/odoo";
import { getMlProductsReport } from "../../../../../hooks/api/ml";

export default function DownloadProductsDataOption(props) {
    const globalContext = useContext(GlobalContext);
    const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
    const [userEmailVali, setUserEmailVali] = useState(null);
    const [showPricelistModal, setShowPricelistModal] = useState(false);
    const [priceLists, setPriceLists] = useState([]);
    const [selectedPricelists, setSelectedPricelists] = useState([]);
    const [loadingPricelists, setLoadingPricelists] = useState(false);
    const [searchFilter, setSearchFilter] = useState("");
    const [filteredPriceLists, setFilteredPriceLists] = useState([]);
    const configData = {};

    switch (props.format) {
        case 'csv':
            configData.icon = faFileCsv;
            configData.title = "Descarga data en CSV";
            configData.responseType = 'json';
            break;

        case 'xlsx':
            configData.icon = faFileExcel;
            configData.title = "Descarga data en Excel";
            configData.responseType = 'arraybuffer';
            break;
    }

    /**
     * Cancel axios requests before unmount
     */
    useEffect(() => {
        return () => {
            axiosCancelTokenSource.cancel("Canceled by unmount");
        };
        //eslint-disable-next-line
    }, []);

    /**
     * Filter pricelists based on search
     */
    useEffect(() => {
        if (searchFilter.trim() === "") {
            setFilteredPriceLists(priceLists);
        } else {
            const filtered = priceLists.filter(pricelist =>
                pricelist.name.toLowerCase().includes(searchFilter.toLowerCase())
            );
            setFilteredPriceLists(filtered);
        }
    }, [searchFilter, priceLists]);
    
    // useEffect(() => {

    //     const v_userEmail = localStorage.getItem(userEmail);

    //     if (!v_userEmail) {
    //         // setRedirect(<Redirect to="/login" />);
    //         globalContext.setVerifyLogin(true);
    //     } else {
    //         globalContext.setVerifyLogin(false);
    //         setUserEmailVali(v_userEmail);

    //     }
    // }, [localStorage.getItem(userEmail)]);

    /**
     * Handle the axios error
     * @param {Error} err The thrown error
     * @param {string} msg A message to show in the modal
     * @param {boolean} consoleLog If should log the error in the console
     */
    const handleAxiosError = (err, msg = null, consoleLog = true) => {
        if (axios.isCancel(err)) return; //Don't show axios cancel error
        
        if (err.response && err.response.data && err.response.data.message) {
            globalContext.showModalWithMsg(err.response.data.message);
        } else if (msg) {
            globalContext.showModalWithMsg(msg);
        }

        if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
    };

    /**
     * Get available pricelists for the current enterprise
     */
    const fetchPricelists = async () => {
        const entId = globalContext.currentEnterpriseId;
        if (!entId) return;

        setLoadingPricelists(true);
        
        try {   
            const response = await getPricelistsFromAPI(entId);

            if (response.data && response.data.data && response.data.data.priceLists) {
                setPriceLists(response.data.data.priceLists);
                setFilteredPriceLists(response.data.data.priceLists);
                // Set default pricelist as selected
                const defaultPricelist = response.data.data.priceLists.find(pl => pl.isDefault);
                if (defaultPricelist) {
                    setSelectedPricelists([defaultPricelist.name]);
                }
            }
        } catch (err) {
            handleAxiosError(err, "Error al cargar las listas de precios");
        } finally {
            setLoadingPricelists(false);
        }
    };

    /**
     * Handle opening the pricelist modal for Odoo
     */
    const handleOdooDownload = () => {
        setShowPricelistModal(true);
        setSelectedPricelists([]); // Reset selections
        setSearchFilter(""); // Reset search
        fetchPricelists();
    };

    /**
     * Handle pricelist selection (checkbox)
     */
    const handlePricelistToggle = (pricelistName) => {
        setSelectedPricelists(prev => {
            if (prev.includes(pricelistName)) {
                // Remove if already selected
                return prev.filter(name => name !== pricelistName);
            } else {
                // Add if not selected
                return [...prev, pricelistName];
            }
        });
    };

    /**
     * Select all filtered pricelists
     */
    const handleSelectAll = () => {
        const filteredNames = filteredPriceLists.map(pl => pl.name);
        const allFilteredSelected = filteredNames.every(name => selectedPricelists.includes(name));
        
        if (allFilteredSelected) {
            // Remove all filtered items from selection
            setSelectedPricelists(prev => prev.filter(name => !filteredNames.includes(name)));
        } else {
            // Add all filtered items to selection (avoiding duplicates)
            setSelectedPricelists(prev => {
                const newSelections = filteredNames.filter(name => !prev.includes(name));
                return [...prev, ...newSelections];
            });
        }
    };

    /**
     * Remove a selected pricelist
     */
    const handleRemovePricelist = (pricelistName) => {
        setSelectedPricelists(prev => prev.filter(name => name !== pricelistName));
    };

    /**
     * Make the download request with selected pricelists
     * Usa la nueva API de Odoo optimizada con columnas dinámicas para linkedTo
     */
    const downloadDataWithPricelist = () => {
        if (!selectedPricelists || selectedPricelists.length === 0) {
            globalContext.showModalWithMsg("Por favor selecciona al menos una lista de precios");
            return;
        }

        globalContext.setLoaderPage(true);
        setShowPricelistModal(false);

        // Usar la nueva API de reportes de Odoo
        const filter = {
            title: props.filter,
            barCode: props.filter,
            refInt: props.filter,
            filterLinkedTo: props.filterLinkedTo,
            filterPrice: props.filterPrice,
            filterStock: props.filterStock,
            filterWithCompany: props.filterWithCompany,
        };

        getOdooProductsReport(
            globalContext.currentEnterpriseId,
            props.format,
            selectedPricelists.join(','),
            filter
        )
            .then((res) => {
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con éxito, se estará ejecutando en segundo plano.`
                );
            })
            .catch((err) => {
                if (axios.isCancel(err)) return; //Don't show axios cancel error

                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrió un error al descargar su archivo`
                );
            });
    };

    /**
     * Make the download request and then open the data as a file
     */
    const downloadData = () => {
        // If it's Odoo, show pricelist selection modal first
        if (props.currentPlugin === 'odoo') {
            handleOdooDownload();
            return;
        }

        globalContext.setLoaderPage(true);
        
        if(props.currentPlugin === 'cashea'){
            getReport(globalContext.currentEnterpriseId, props.format).then(res =>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                );
            }).catch(()=>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrio un error al descargar su archivo`
                );
            })
        }

        else if(props.currentPlugin === 'vtex'){
            getReportVtex(globalContext.currentEnterpriseId, props.format).then(res =>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                );
            }).catch(()=>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrio un error al descargar su archivo`
                );
            })
        }
        else if(props.currentPlugin === 'homeCenter'){
            console.log('hc')
            getReportHomeCenter(globalContext.currentEnterpriseId, props.format).then(res =>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                );
            }).catch(()=>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrio un error al descargar su archivo`
                );
            })
        }
        else if(props.currentPlugin === 'fl'){
            getReportFalabella(globalContext.currentEnterpriseId, props.format).then(res =>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                );
            }).catch(()=>{
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrio un error al descargar su archivo`
                );
            })
        }
        else if(props.currentPlugin === 'ml' || props.currentPlugin === 'ML'){
            // Usar nueva API optimizada para reportes de ML
            const filter = {
                title: props.filter,
                barCode: props.filter,
                refInt: props.filter,
                filterLinkedTo: props.filterLinkedTo,
                filterPrice: props.filterPrice,
                filterStock: props.filterStock,
                filterWithCompany: props.filterWithCompany,
            };
            
            getMlProductsReport(globalContext.currentEnterpriseId, props.format, filter)
                .then(res =>{
                    globalContext.setLoaderPage(false);
                    globalContext.showModalWithMsg(
                        `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                    );
                })
                .catch((err) => {
                    if (axios.isCancel(err)) return; //Don't show axios cancel error
                    globalContext.setLoaderPage(false);
                    globalContext.showModalWithMsg(
                        `Ocurrio un error al descargar su archivo`
                    );
                });
        }
        else{
            axios
            .get(
                `${process.env.REACT_APP_BACKEND_URL}/v1/product/${globalContext.currentEnterpriseId}/report/${props.currentPlugin}/${props.format}`,
                {
                    cancelToken: axiosCancelTokenSource.token,
                    headers: {
                        "x-api-key": process.env.REACT_APP_API_KEY,
                        "x-access-token": localStorage.getItem(keyAccessToken),
                        "x-user-id": localStorage.getItem(keyUserId),
                    },
                    params: {
                        filter: {
                            title: props.filter,
                            barCode: props.filter,
                            refInt: props.filter,
                            filterLinkedTo: props.filterLinkedTo,
                            filterPrice: props.filterPrice,
                            filterStock: props.filterStock,
                            filterWithCompany: props.filterWithCompany,
                        },
                    },
                    responseType: configData.responseType,
                }
            )
            .then((res) => {
                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `La descarga inicio con exito, se estara ejecutando en segundo plano.`
                );

            })
            .catch((err) => {
                if (axios.isCancel(err)) return; //Don't show axios cancel error

                globalContext.setLoaderPage(false);
                globalContext.showModalWithMsg(
                    `Ocurrio un error al descargar su archivo`
                );
            });
        }
    };


    return (
        <>
            <div
                className={`items`}
                onClick={downloadData}
            >
                <span className="ic">
                    <FontAwesomeIcon icon={configData.icon} />
                </span>
                <p>{configData.title}</p>
            </div>

            {/* Modal for Pricelist Selection */}
            <Modal 
                show={showPricelistModal} 
                onHide={() => setShowPricelistModal(false)}
                backdrop="static"
                keyboard={false}
                onClick={(e) => e.stopPropagation()}
                style={{ zIndex: 9999 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Lista de Precios</Modal.Title>
                </Modal.Header>
                <Modal.Body onClick={(e) => e.stopPropagation()}>
                    {loadingPricelists ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Cargando...</span>
                            </div>
                            <p className="mt-2">Cargando listas de precios...</p>
                        </div>
                    ) : (
                        <div>
                            {/* Buscador */}
                            <div className="mb-3">
                                <Form.Label>Buscar Listas de Precios:</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Escribe para buscar tarifas..."
                                    value={searchFilter}
                                    onChange={(e) => setSearchFilter(e.target.value)}
                                    onClick={(e) => e.stopPropagation()}
                                    style={{ marginBottom: '10px' }}
                                />
                            </div>

                            {/* Tarifas Seleccionadas (Chips/Tags) */}
                            {selectedPricelists.length > 0 && (
                                <div className="mb-3">
                                    <Form.Label>Tarifas Seleccionadas ({selectedPricelists.length}):</Form.Label>
                                    <div className="d-flex flex-wrap p-2 border rounded bg-light" style={{gap: '10px'}}>
                                        {selectedPricelists.map((pricelistName, index) => (
                                            <span 
                                                key={index}
                                                className="badge bg-primary d-flex align-items-center"
                                                style={{ fontSize: '0.9em', padding: '6px 14px', color: 'white' }}
                                            >
                                                {pricelistName}
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    style={{ fontSize: '0.7em', marginLeft: '6px' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemovePricelist(pricelistName);
                                                    }}
                                                    aria-label="Remover"
                                                ></button>
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Lista de Tarifas Disponibles */}
                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <Form.Label className="mb-0">
                                        Tarifas Disponibles {searchFilter && `(${filteredPriceLists.length} encontradas)`}:
                                    </Form.Label>
                                    {filteredPriceLists.length > 0 && (
                                        <Button 
                                            variant="outline-primary" 
                                            size="sm"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleSelectAll();
                                            }}
                                        >
                                            {filteredPriceLists.every(pl => selectedPricelists.includes(pl.name)) 
                                                ? "Quitar Filtradas" 
                                                : "Agregar Filtradas"}
                                        </Button>
                                    )}
                                </div>
                                
                                <div style={{ 
                                    maxHeight: '200px', 
                                    overflowY: 'auto', 
                                    border: '1px solid #ced4da', 
                                    borderRadius: '0.25rem', 
                                    backgroundColor: '#f8f9fa'
                                }}>
                                    {filteredPriceLists.length === 0 ? (
                                        <div className="p-3 text-center text-muted">
                                            {searchFilter ? 'No se encontraron tarifas que coincidan con la búsqueda' : 'No hay tarifas disponibles'}
                                        </div>
                                    ) : (
                                        filteredPriceLists.map((pricelist, index) => {
                                            const isSelected = selectedPricelists.includes(pricelist.name);
                                            return (
                                                <div 
                                                    key={index}
                                                    className={`p-2 border-bottom cursor-pointer ${isSelected ? 'bg-primary text-white' : 'bg-white'}`}
                                                    style={{ 
                                                        cursor: 'pointer',
                                                        transition: 'all 0.2s ease',
                                                        userSelect: 'none'
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePricelistToggle(pricelist.name);
                                                    }}
                                                >
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <span>
                                                            <strong>{pricelist.name}</strong>
                                                            {pricelist.isDefault && (
                                                                <span className={`ms-1 badge bg-warning text-dark`}
                                                                style={{marginLeft: '13px'}}>
                                                                    Por defecto
                                                                </span>
                                                            )}
                                                        </span>
                                                        {isSelected && (
                                                            <span className="badge bg-light text-primary">✓ Seleccionada</span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            </div>
                            
                            <div className="text-muted">
                                <small>
                                    💡 <strong>Tip:</strong> Selecciona múltiples tarifas para generar reportes comparativos. 
                                    Cada tarifa aparecerá como una columna separada en el Excel.
                                    {priceLists.length > 0 && priceLists.find(pl => pl.isDefault) && 
                                        ` La tarifa por defecto es: ${priceLists.find(pl => pl.isDefault).name}.`
                                    }
                                </small>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer onClick={(e) => e.stopPropagation()}>
                    <Button 
                        variant="secondary" 
                        onClick={(e) => {
                            e.stopPropagation();
                            setShowPricelistModal(false);
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={(e) => {
                            e.stopPropagation();
                            downloadDataWithPricelist();
                        }}
                        disabled={selectedPricelists.length === 0 || loadingPricelists}
                    >
                        Descargar Reporte
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}